import React from 'react';
import appNavigationNames, { withActiveTab } from '../../utils/appNavigationNames';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { getIntl } from '../../utils/intl';
import { screens } from '../screens/Tabs/Notes';
import { MaybeDrawerLayout } from '../shared/MaybeSideNavLayout';
import { colors } from '../../utils/theme';
import { getHeader, mobileHeaderConfigs } from '../v2BaseComponents/Header';
import { useCapturedUrlUTMParameters } from '../../hooks/useUrlUTMParameters';

const intl = getIntl('notes-navigator', {
    note: 'My Notes',
    addNote: 'Add Note',
    editNote: 'Edit Note',
    transferNote: 'Move Note',
    sendNote: 'Share Note',
});

const Stack = createNativeStackNavigator();

const NotesNavigation = () => {
    const capturedUrlUTMParameters = useCapturedUrlUTMParameters();

    return (
        <MaybeDrawerLayout>
            <Stack.Navigator initialRouteName={appNavigationNames.notes.root}>
                <Stack.Screen
                    options={{
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['user-notes'],
                        }),
                        title: intl('note'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.notes.root}
                    component={screens.NotesRootScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        title: intl('addNote'),
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['user-notes', 'add-note'],
                        }),
                    }}
                    name={appNavigationNames.notes.add}
                    component={screens.AddNoteScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        title: intl('note'),
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['user-notes', 'user-note'],
                        }),
                    }}
                    name={appNavigationNames.notes.details}
                    component={screens.NoteDetailsScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        title: intl('editNote'),
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['user-notes', 'user-note', 'edit-note'],
                        }),
                    }}
                    name={appNavigationNames.notes.edit}
                    component={screens.NoteEditScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        title: intl('transferNote'),
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['user-notes', 'user-note', 'transfer-note'],
                        }),
                    }}
                    name={appNavigationNames.notes.transfer}
                    component={screens.NoteTransferScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        title: intl('sendNote'),
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['user-notes', 'user-note', 'send-note'],
                        }),
                    }}
                    name={appNavigationNames.notes.send}
                    component={screens.SendNoteScreen}
                    initialParams={capturedUrlUTMParameters}
                />
            </Stack.Navigator>
        </MaybeDrawerLayout>
    );
};

export default withActiveTab(NotesNavigation, 'notes');
